import { request } from 'src/api/request';

export const getVolumeByLocation = async ({ providerId, queryParams }) => {
  if (!providerId) return;

  return request({
    url: `v1/providers/${providerId}/volume-by-location/${queryParams}`,
    method: 'GET',
  });
};
